<template>
  <div id="app">
    <div style="position: absolute;left: 0px;top:0px; width:100%; height:100%">
      <ArticleList :key="$route.fullPath"/>
    </div>
    <transition enter-active-class="animated slideInRight"
                leave-active-class="animated slideOutRight">
      <div v-if="$route.name=='Article'" style="position: absolute;left: 0px;top:0px; width:100%; height:100%;animation-duration: 0.3s;-webkit-animation-duration: 0.3s;">
          <Article :key="$route.fullPath" style="animation-duration: 0.3s;-webkit-animation-duration: 0.3s;"></Article>
      </div>
    </transition>
  </div>
</template>

<script>
import store from './store/'

import ArticleList from './components/ArticleList'
import Article from './components/Article'

import preview from "./components/preview";

export default {
  name: 'App',
  store,
  components:{
    ArticleList,
    Article,
    preview
  },
  mounted(){
    //获取自适应参数
    window.onresize=function () {
      this.$store.commit("WindowSizeNoSet");
    }.bind(this)
    this.$store.commit("WindowSizeNoSet");

    this.getShareInfo();
    this.count(0,0,3)
  },
  methods:{
    getShareInfo(){
      let params = new URLSearchParams();
      params.append('id', 'primo');

      this.axios.post('wx_jssdk.php',params)
        .then((response)=>{
          let res=response.data
          wx.config({
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: [
              'onMenuShareTimeline',
              'onMenuShareAppMessage'
            ]
          });

          wx.ready(function () {
            this.setShare();
          }.bind(this));
          wx.error(function(res){
            console.log(res)
          });
        })
        .catch((error)=>{
          console.log(error);
        });
    },
    count(isshare,id,issue){
      let params = new URLSearchParams();
      params.append('id', id);
      params.append('issue', issue);
      params.append('isshare', isshare);
      let chanel=getQueryVariable('chanel');
      if(!chanel) chanel=100;
      params.append('chanel', chanel);
      let isview=this.$cookies.get('isview_'+id+"_"+issue);
      if(isview) {
        params.append('isview', 1);
      }else{
        params.append('isview', 0);
        this.$cookies.set('isview_'+id+"_"+issue,1,'1d')
      }

      this.axios.post('count.php',params)
        .then((response)=>{
          console.log(response.data)
        })
        .catch((error)=>{
          console.log(error);
        });
    },
    setShare(){
      let shareData = {
        title:this.$store.state.ShareInfo.title,
        desc: this.$store.state.ShareInfo.desc,
        link: this.$store.state.ShareInfo.link,
        imgUrl: require('./assets/'+this.$store.state.ShareInfo.icon),
        success:function(){
          this.count(1,this.$store.state.ShareInfo.id,this.$store.state.ShareInfo.issue);
        }.bind(this)
      };
      wx.onMenuShareAppMessage(shareData);
      wx.onMenuShareTimeline(shareData);
    }
  }
}
</script>
<style>
body,html,#app{
  width: 100%;
  height: 100%;
}
body{
  font-family:"微软雅黑";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  padding:0;
  margin:0;
  border:0;
  overflow: hidden;

  -webkit-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
  -moz-text-size-adjust: 100% !important;
}
div,img,video{
  display: block;
  float: left;
}

#app{
  overflow: hidden;
  box-shadow: 0px 0px .15rem .01rem #cccccc;
}
.ArticleNomalText{
  text-align: justify;
  font-size: .42rem;
  color: #666666;
  line-height: .84rem;
  margin-block-end: .642rem;
  margin-block-start: 0.22rem;
}

.ArticleNomalText b{
  text-align: justify;
  font-size: .42rem;
  color: #303030;
  line-height: .84rem;
  margin-block-end: .22rem;
  margin-block-start: 0.22rem;
}
.ArticleTitleText{
  font-size:.448rem;
  color:#000000;
  /* line-height: .84rem; */
  margin-block-end: -0.1rem;
  margin-block-start: .46rem;
  padding-top: 0.8rem;

}
.ArticleFontCentered{
  text-align: center;
  font-size: 0.42rem;
  color:#666666;
  font-weight: 600;
  margin-top: 0rem;
}
</style>



// WEBPACK FOOTER //
// src/App.vue